import React from 'react';
import { createPortal } from 'react-dom';
import {ChatNotificationFloatingHostCodeComponent} from 'react/chat/inner/display_pieces/messages/notifications/ChatNotificationFloatingHostCodeComponent.jsx';

// Floats the host code over the page from #subtree-container (positioned in
// _ladder.scss) instead of inside the chat message that announced it.
function subtreeContainer() {
	let container = document.getElementById('subtree-container');
	if(!container) {
		container = document.createElement('div');
		container.id = 'subtree-container';
		document.body.appendChild(container);
	}
	return container;
}

function FloatingHostCode(props) {
	return createPortal(<ChatNotificationFloatingHostCodeComponent {...props} />, subtreeContainer());
}

export {FloatingHostCode};
